(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('.cc-product-carousel');

    carousels.forEach((section) => {
      if (section.dataset.carouselInitialized === 'true') {
        return;
      }

      section.dataset.carouselInitialized = 'true';

      const track = section.querySelector('[data-carousel-track]');

      const previousButton = section.querySelector('[data-carousel-prev]');

      const nextButton = section.querySelector('[data-carousel-next]');

      const progress = section.querySelector('[data-carousel-progress]');

      if (!track) {
        return;
      }

      /* ======================================================
       GET SCROLL AMOUNT
    ====================================================== */

      const getScrollAmount = () => {
        const item = track.querySelector('.cc-product-carousel__item');

        if (!item) {
          return track.clientWidth;
        }

        const gap = parseFloat(getComputedStyle(track).gap) || 0;

        return item.getBoundingClientRect().width + gap;
      };

      /* ======================================================
       UPDATE BUTTONS + PROGRESS
    ====================================================== */

      const updateControls = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

        const currentScroll = track.scrollLeft;

        /* ==========================================
     BUTTONS
  ========================================== */

        if (previousButton) {
          previousButton.disabled = currentScroll <= 1;
        }

        if (nextButton) {
          nextButton.disabled = currentScroll >= maxScroll - 1;
        }

        /* ==========================================
     DYNAMIC PROGRESS
  ========================================== */

        if (progress) {
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

          const currentScroll = track.scrollLeft;

          if (maxScroll <= 0) {
            progress.style.left = '0%';
            progress.style.width = '100%';
          } else {
            const scrollPercent = currentScroll / maxScroll;

            /*
             * Active line width.
             * Screenshot જેવી short line.
             */
            const activeWidth = 35;

            /*
             * Active line maximum movement.
             */
            const maxLeft = 100 - activeWidth;

            const leftPosition = scrollPercent * maxLeft;

            progress.style.left = `${leftPosition}%`;

            progress.style.width = `${activeWidth}%`;
          }
        }
      };

      /* ======================================================
       PREVIOUS
    ====================================================== */

      if (previousButton) {
        previousButton.addEventListener('click', () => {
          track.scrollBy({
            left: -getScrollAmount(),

            behavior: 'smooth',
          });
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          track.scrollBy({
            left: getScrollAmount(),

            behavior: 'smooth',
          });
        });
      }
      track.addEventListener('scroll', updateControls, {
        passive: true,
      });
      window.addEventListener('resize', updateControls);

      requestAnimationFrame(updateControls);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const initProductListCarousels = () => {

      const carousels = document.querySelectorAll(
        '.cc-product-list-carousel'
      );

      carousels.forEach((section) => {

        if (section.dataset.carouselInitialized === 'true') {
          return;
        }

        section.dataset.carouselInitialized = 'true';

        const track = section.querySelector(
          '[data-product-list-track]'
        );

        const previousButton = section.querySelector(
          '[data-product-list-prev]'
        );

        const nextButton = section.querySelector(
          '[data-product-list-next]'
        );

        const progress = section.querySelector(
          '[data-product-list-progress]'
        );

        if (!track) {
          return;
        }

        const getScrollAmount = () => {

          const item = track.querySelector(
            '.cc-product-list-carousel__item'
          );

          if (!item) {
            return track.clientWidth;
          }

          const gap =
            parseFloat(
              getComputedStyle(track).gap
            ) || 0;

          return (
            item.getBoundingClientRect().width +
            gap
          );
        };

        const updateControls = () => {

          const maxScroll = Math.max(
            0,
            track.scrollWidth - track.clientWidth
          );

          const currentScroll =
            track.scrollLeft;

          if (previousButton) {
            previousButton.disabled =
              currentScroll <= 1;
          }

          if (nextButton) {
            nextButton.disabled =
              currentScroll >= maxScroll - 1;
          }

          if (progress) {

            if (maxScroll <= 0) {

              progress.style.left = '0%';
              progress.style.width = '100%';

            } else {

              const percentage =
                currentScroll / maxScroll;

              const activeWidth = 35;

              const maxLeft =
                100 - activeWidth;

              progress.style.left =
                `${percentage * maxLeft}%`;

              progress.style.width =
                `${activeWidth}%`;
            }
          }
        };

        if (previousButton) {

          previousButton.addEventListener(
            'click',
            () => {

              track.scrollBy({
                left: -getScrollAmount(),
                behavior: 'smooth'
              });

            }
          );

        }

        if (nextButton) {

          nextButton.addEventListener(
            'click',
            () => {

              track.scrollBy({
                left: getScrollAmount(),
                behavior: 'smooth'
              });

            }
          );

        }

        track.addEventListener(
          'scroll',
          updateControls,
          {
            passive: true
          }
        );

        window.addEventListener(
          'resize',
          updateControls
        );

        requestAnimationFrame(
          updateControls
        );

      });

    };

    initProductListCarousels();

    document.addEventListener(
      'shopify:section:load',
      initProductListCarousels
    );

  })();


  } catch(e) { console.error(e); }
})();
})();
